import React from 'react';
import { pluginCode } from 'drapcode-constant';
import MagicLinkLogin from './MagicLinkLogin';
import Typeform from './Typeform';
import TwitterWidget from './TwitterWidget';
import Twilio from './Twilio';
import AwsSns from './AwsSns';
import TrustpilotWidget from './TrustpilotWidget';
import SurveyMonkey from './SurveyMonkey';
import Subscribe from './Subscribe';
import GetSiteControl from './GetSiteControl';
import Plaid from './Plaid';
import FacebookWidget from './FacebookWidget';
import PinterestWidget from './PinterestWidget';
import GoogleAnalytics from './GoogleAnalytics';
import ElfsightWidget from './ElfsightWidget';
import Calendly from './Calendly';
import AtomChat from './AtomChat';
import MultiTenant from './MultiTenant';
import StripeConnect from './StripeConnect';
import Snipcart from './Snipcart';
import AmazonSes from './AmazonSes';
import Landbot from './Landbot';
import Login from './Login';
import GoogleMap from './GoogleMap';
import QuestionnaireSurvey from './QuestionnaireSurvey';
import BackendlessAuth from './BackendlessAuth';

const ShowPluginDocs = ({ code }) => {
  console.log(code, 'from ShowPlugin.js line number 31');
  switch (code) {
    case pluginCode.LOGIN:
      return <Login />;
    case 'GOOGLE_MAP':
      return <GoogleMap />;
    case 'LANDBOT':
      return <Landbot />;
    case 'AWS_SES':
      return <AmazonSes />;
    case 'SNIPCART':
      return <Snipcart />;
    case 'STRIPE_CONNECT':
      return <StripeConnect />;
    case 'MULTI_TENANT_SAAS':
      return <MultiTenant />;
    case 'ATOM_CHAT':
      return <AtomChat />;
    case 'CALENDLY':
      return <Calendly />;
    case pluginCode.LOGIN_WITH_BACKENDLESS:
      return <BackendlessAuth />;
    case 'ELFSIGHT_WIDGET':
      return <ElfsightWidget />;
    case 'GOOGLE_ANALYTICS':
      return <GoogleAnalytics />;
    case 'QUESTIONNAIRE_SURVEY_FORM':
      return <QuestionnaireSurvey />;
    case 'PINTEREST_WIDGET':
      return <PinterestWidget />;
    case 'FACEBOOK_WIDGET':
      return <FacebookWidget />;
    case 'PLAID':
      return <Plaid />;
    case 'GETSITECONTROL':
      return <GetSiteControl />;
    case 'SUBSCRIBE':
      return <Subscribe />;
    case 'SURVEYMONKEY':
      return <SurveyMonkey />;
    case 'TRUSTPILOT_WIDGET':
      return <TrustpilotWidget />;
    case pluginCode.TWILIO:
      return <Twilio />;
    case pluginCode.AWS_SNS:
      return <AwsSns />;
    case pluginCode.TWITTER_WIDGET:
      return <TwitterWidget />;
    case pluginCode.TYPEFORM:
      return <Typeform />;
    case pluginCode.MAGIC_LINK_LOGIN:
      return <MagicLinkLogin />;
    default:
      return '';
  }
  return <div>ShowPluginDocs</div>;
};

export default ShowPluginDocs;
